import { useEffect, useState } from 'react'
import { Box, Container, Link, Typography } from '@mui/material'

const APP_STORE_URL = 'https://apps.apple.com/ca/app/transpots/id6753125956'
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.transpots.driver.android'

type Platform = 'ios' | 'android' | 'other'

const detectPlatform = (): Platform => {
  const ua = navigator.userAgent || ''
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  if (/Android/i.test(ua)) return 'android'
  return 'other'
}

const AppDownloadPage = () => {
  const [platform, setPlatform] = useState<Platform | null>(null)

  useEffect(() => {
    const detected = detectPlatform()
    setPlatform(detected)

    if (detected === 'ios') {
      window.location.replace(APP_STORE_URL)
      return
    }
    if (detected === 'android') {
      window.location.replace(PLAY_STORE_URL)
    }
  }, [])

  const isRedirecting = platform === 'ios' || platform === 'android'

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        px: 2,
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center', py: 6 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 700, mb: 1, color: '#111' }}
        >
          Transpots
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#444' }}>
          {isRedirecting
            ? 'Opening the store…'
            : 'Download the Transpots driver app to get started.'}
        </Typography>

        {!isRedirecting && (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Link
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
            >
              <Box
                component="img"
                src="/badges/app-store-badge.svg"
                alt="Download on the App Store"
                sx={{ height: 54, display: 'block' }}
              />
            </Link>
            <Link
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
            >
              <Box
                component="img"
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
                sx={{ height: 80, display: 'block' }}
              />
            </Link>
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default AppDownloadPage
